'use client';
import React, { useState, useEffect } from 'react';
import {
	Button,
	Typography,
	Col,
	Row,
	Input,
	Modal,
	Form,
	Select,
	Spin,
	notification,
	InputNumber,
	Divider
} from 'antd';
import axios from 'axios';
import moment from 'moment';
import _, { truncate } from 'lodash';
import { InputDate, ProvinceSelector } from 'afrodita';
import TextArea from 'antd/lib/input/TextArea';
import { ContactBookIcon, Home10Icon, House03Icon } from 'hugeicons-react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import env from '../../../../../../environment';
import authClient from '../../../../../../Auth/Auth';

const { Text } = Typography;
const { Option } = Select;

const TableLaboralKutxa = ({ bankRequestId, mortgageId, mortgage, type }) => {
	const brand = process.env.NEXT_PUBLIC_BRAND;
	const [form] = Form.useForm();
	const navigate = useNavigate();
	const [visibleCancel, setVisibleCancel] = useState<any>(false);
	const [provinces, setProvinces] = useState<any>(undefined);
	const [municipes, setMunicipes] = useState<any>(undefined);
	const [otherDatasAll, setOtherDatasAll] = useState<any>(undefined);
	const [data, setData] = useState<any>([]);
	const [loading, setLoading] = useState<any>(false);
	const [value, setValue] = useState<any>(undefined);
	let timeout;
	let currentValue;
	const params = useParams();
	const [emptyFields, setEmptyFields] = useState<any>([]);
	const [bankRequest, setBankRequest] = useState<any>(undefined);
	const [documentsTypes, setDocumentsTypes] = useState<any>(undefined);
	const numberParticipants = parseInt(mortgage?.mortgage?.participants) || 1;
	const [allData, setAllData] = useState<any>(undefined);
	const [countries, setContries] = useState<any>(undefined);
	const [valueCivilStatus, setValueCivilStatus] = useState<any>(undefined);

	useEffect(() => {
		getBankRequest();
		getProvinces();
		axios.get(`${env.api.url}/v1/countries`).then((response) => {
			setContries(response.data.data);
		});
	}, []);

	useEffect(() => {
		if (mortgage && provinces && otherDatasAll) {
			const values = form.getFieldsValue();
			const undefinedFields = Object.entries(values)
				.filter(
					([fieldName, value]) => value === undefined || value === '' || value === 'Fecha inválida'
				)
				.map(([fieldName]) => fieldName);
			setEmptyFields(undefinedFields);
		}
	}, [form, mortgage, provinces, otherDatasAll]);

	const getBankRequest = () => {
		axios
			.get(`${env.api.url}/banks/bank-request/find-by-id/${bankRequestId}`, {
				headers: {
					Authorization: `Bearer ${authClient.getToken()}`
				}
			})
			.then((response) => {
				setBankRequest(response.data.data);
			});
	};
	const handleFormChange = () => {
		const values = form.getFieldsValue();
		const undefinedFields = Object.entries(values)
			.filter(
				([fieldName, value]) => value === undefined || value === '' || value === 'Fecha inválida'
			)
			.map(([fieldName]) => fieldName);
		setEmptyFields(undefinedFields);
	};

	const getProvinces = () => {
		axios
			.get(`${env.api.url}/banks/laboral-kutxa/data`, {
				headers: {
					Authorization: `Bearer ${authClient.getToken()}`
				}
			})
			.then((response) => {
				setAllData(response.data.data);
				setDocumentsTypes(response.data.data.documentIdType);
			});
	};

	const search = (value) => {
		if (timeout) {
			clearTimeout(timeout);
			timeout = null;
		}
		currentValue = value;

		const searchData = () => {
			axios.get(`${env.api.url}/banks/uci/data/municipes?search=${value}`).then((response) => {
				if (currentValue === value) {
					setData(response.data.data.municipes);
				}
			});
		};
		timeout = setTimeout(searchData, 300);
	};

	const renderForm = () => {
		const arrayform: any = [];

		for (let index = 1; index <= numberParticipants; index++) {
			arrayform.push(
				<>
					<Row style={{ marginTop: index === 1 ? 24 : 16 }}>
						<div style={{ display: 'flex', alignItems: 'center', gap: 8, width: '100%' }}>
							<div style={{ display: 'flex', width: 70 }}>
								<Text
									style={{
										fontSize: 14,
										fontWeight: 600
									}}>
									{'Titular ' + index}
								</Text>
							</div>
							<div style={{ height: 1, width: '100%', background: '#212121', flexGrow: 1 }}></div>
						</div>
					</Row>
					<Row gutter={[32, 0]} style={{ marginTop: 16 }}>
						<Col xs={12} md={8} sm={8} lg={8} xl={6} xxl={6}>
							<Form.Item
								name={'Nombre' + index}
								rules={[{ required: true, message: 'Por favor, rellene este campo' }]}
								label={<Text style={{ fontSize: 10, fontWeight: 400 }}>{`Nombre`}</Text>}>
								<Input style={{ width: '100%' }} placeholder="Nombre" />
							</Form.Item>
						</Col>
						<Col xs={12} md={8} sm={8} lg={8} xl={6} xxl={6}>
							<Form.Item
								name={'PrimerApellido' + index}
								rules={[{ required: true, message: 'Por favor, rellene este campo' }]}
								label={<Text style={{ fontSize: 10, fontWeight: 400 }}>{`Apellido 1`}</Text>}>
								<Input style={{ width: '100%' }} placeholder="Apellido 1" />
							</Form.Item>
						</Col>
						<Col xs={12} md={8} sm={8} lg={8} xl={6} xxl={6}>
							<Form.Item
								name={'SegundoApellido' + index}
								rules={[{ required: true, message: 'Por favor, rellene este campo' }]}
								label={<Text style={{ fontSize: 10, fontWeight: 400 }}>{`Apellido 2`}</Text>}>
								<Input style={{ width: '100%' }} placeholder="Apellido 2" />
							</Form.Item>
						</Col>
						<Col xs={12} md={8} sm={8} lg={8} xl={6} xxl={6}>
							<Form.Item
								name={'FechaDeNacimiento' + index}
								rules={[{ required: true, message: 'Por favor, rellene este campo' }]}
								label={
									<Text
										style={{
											fontSize: 10,
											fontWeight: 400
										}}>{`Fecha de nacimiento`}</Text>
								}>
								<InputDate
									type="date"
									style={{ width: '100%' }}
									// onChange={handleFormChange}
									placeholder="Fecha de nacimiento"
								/>
							</Form.Item>
						</Col>

						<Col xs={12} md={8} sm={3} lg={3} xl={3} xxl={3}>
							<Form.Item
								name={'TipoDeDocumento' + index}
								label={
									<Text style={{ fontSize: 10, fontWeight: 400 }}>{'DNI/ NIE/ Pasaporte'}</Text>
								}
								className={emptyFields.includes('nifType') ? 'shadowed' : ''}
								rules={[{ required: true, message: 'Por favor, rellene este campo' }]}>
								<Select
									showSearch
									onChange={handleFormChange}
									filterOption={(input, option: any) =>
										option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
									}
									style={{ width: '100%', borderRadius: 4 }}
									filterSort={(optionA, optionB) =>
										optionA?.children?.toLowerCase().localeCompare(optionB.children.toLowerCase())
									}
									placeholder="Seleccionar">
									{documentsTypes.map((data) => (
										<Option key={data.code} value={data.name}>
											{data.label}
										</Option>
									))}
								</Select>
							</Form.Item>
						</Col>

						<Col xs={12} md={8} sm={3} lg={3} xl={3} xxl={3}>
							<Form.Item
								name={'NumeroDeDocumento' + index}
								label={<Text style={{ fontSize: 10, fontWeight: 400 }}>{'Número'}</Text>}
								rules={[{ required: true, message: 'Por favor, rellene este campo' }]}>
								<Input style={{ width: '100%' }} type="text" placeholder="Número" />
							</Form.Item>
						</Col>

						<Col xs={12} md={8} sm={8} lg={8} xl={6} xxl={6}>
							<Form.Item
								name={'Nacionalidad' + index}
								label="Nacionalidad"
								rules={[{ required: true, message: 'Por favor, rellene este campo' }]}>
								<Select
									showSearch
									style={{ width: '100%', borderRadius: 4 }}
									placeholder="Seleccionar"
									filterOption={(input: any, option: any) =>
										option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
										option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
									}>
									{countries &&
										countries.countries.map((paises) => (
											<Option key={paises.code} value={paises.name_es}>
												{paises.name_es}
											</Option>
										))}
								</Select>
							</Form.Item>
						</Col>
						<Col xs={12} md={8} sm={8} lg={8} xl={6} xxl={6}>
							<Form.Item
								name={'PaisDeResidencia' + index}
								label="País de residencia"
								rules={[{ required: true, message: 'Por favor, rellene este campo' }]}>
								<Select
									showSearch
									style={{ width: '100%', borderRadius: 4 }}
									placeholder="Seleccionar"
									filterOption={(input: any, option: any) =>
										option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
										option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
									}>
									{countries &&
										countries.countries.map((paises) => (
											<Option key={paises.code} value={paises.name_es}>
												{paises.name_es}
											</Option>
										))}
								</Select>
							</Form.Item>
						</Col>

						<Col xs={12} md={8} sm={8} lg={8} xl={6} xxl={6}>
							<Form.Item
								name={'Provincia' + index}
								label={<Text style={{ fontSize: 10, fontWeight: 400 }}>{`Provincia`}</Text>}
								className={emptyFields.includes('Provincia') ? 'shadowed' : ''}
								rules={[{ required: true, message: 'Por favor, rellene este campo' }]}>
								<ProvinceSelector placeholder="Seleccionar" style={{ width: '100%' }} />
							</Form.Item>
						</Col>

						<Col xs={12} md={8} sm={8} lg={8} xl={6} xxl={6}>
							<Form.Item
								name={'CodigoPostal' + index}
								rules={[{ required: true, message: 'Por favor, rellene este campo' }]}
								label={<Text style={{ fontSize: 10, fontWeight: 400 }}>{`Código postal`}</Text>}>
								<Input style={{ width: '100%' }} placeholder="Código postal " />
							</Form.Item>
						</Col>
						<Col xs={12} md={8} sm={8} lg={8} xl={6} xxl={6}>
							<Form.Item
								name={'EstadoCivil' + index}
								label={<Text style={{ fontSize: 10, fontWeight: 400 }}>{`Estado civil`}</Text>}
								className={emptyFields.includes('EstadoCivil') ? 'shadowed' : ''}
								rules={[{ required: true, message: 'Por favor, rellene este campo' }]}>
								<Select
									showSearch
									onChange={(value) => setValueCivilStatus(value)}
									filterOption={(input, option: any) =>
										option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
									}
									style={{ width: '100%', borderRadius: 4 }}
									filterSort={(optionA, optionB) =>
										optionA?.children?.toLowerCase().localeCompare(optionB?.children?.toLowerCase())
									}
									placeholder="Seleccionar">
									{allData?.maritalStatus?.map((e) => (
										<Option key={e.name} value={e.value}>
											{e.label}
										</Option>
									))}
								</Select>
							</Form.Item>
						</Col>
						{valueCivilStatus === 'Casado' && (
							<Col xs={12} md={8} sm={8} lg={8} xl={6} xxl={6}>
								<Form.Item
									name={'RegimenMatrimonial' + index}
									label={
										<Text style={{ fontSize: 10, fontWeight: 400 }}>{`Regimen matrimonial`}</Text>
									}
									className={emptyFields.includes('') ? 'shadowed' : ''}
									rules={[{ required: true, message: 'Por favor, rellene este campo' }]}>
									<Select
										showSearch
										// onChange={handleFormChange}
										filterOption={(input, option: any) =>
											option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
										}
										style={{ width: '100%', borderRadius: 4 }}
										filterSort={(optionA, optionB) =>
											optionA?.children
												?.toLowerCase()
												.localeCompare(optionB?.children.toLowerCase())
										}
										placeholder="Seleccionar">
										{allData?.matrimonialRegime?.map((e) => (
											<Option key={e.name} value={e.value}>
												{e.label}
											</Option>
										))}
									</Select>
								</Form.Item>
							</Col>
						)}

						<Col xs={12} md={8} sm={8} lg={8} xl={6} xxl={6}>
							<Form.Item
								name={'CorreoElectronico' + index}
								label="Email de contacto"
								rules={[{ required: true, message: 'Por favor, rellene este campo' }]}>
								<Input style={{ width: '100%' }} type="text" placeholder="Correo electrónico" />
							</Form.Item>
						</Col>
					</Row>

					<Row style={{ marginTop: index === 1 ? 24 : 16 }}>
						<div style={{ display: 'flex', alignItems: 'center', gap: 8, width: '100%' }}>
							<div style={{ display: 'flex', width: 300 }}>
								<Text
									style={{
										fontSize: 14,
										fontWeight: 600
									}}>
									{'Datos laborales e ingresos del T' + index}
								</Text>
							</div>
							<div style={{ height: 1, width: '100%', background: '#212121', flexGrow: 1 }}></div>
						</div>
					</Row>
					<Row gutter={[32, 0]} style={{ marginTop: 16 }}>
						<Col xs={12} md={8} sm={8} lg={8} xl={6} xxl={6}>
							<Form.Item
								name={'TipoContrato' + index}
								label={<Text style={{ fontSize: 10, fontWeight: 400 }}>{`Situación laboral`}</Text>}
								className={emptyFields.includes('TipoContrato') ? 'shadowed' : ''}
								rules={[{ required: true, message: 'Por favor, rellene este campo' }]}>
								<Select
									showSearch
									// onChange={handleFormChange}
									filterOption={(input, option: any) =>
										option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
									}
									style={{ width: '100%', borderRadius: 4 }}
									filterSort={(optionA, optionB) =>
										optionA?.children?.toLowerCase().localeCompare(optionB?.children.toLowerCase())
									}
									placeholder="Seleccionar">
									{allData?.employmentContract?.map((e) => (
										<Option key={e.name} value={e.name}>
											{e.label}
										</Option>
									))}
								</Select>
							</Form.Item>
						</Col>
						<Col xs={12} md={8} sm={8} lg={8} xl={6} xxl={6}>
							<Form.Item
								name={'IngresosNetosMensuales' + index}
								label={<Text style={{ fontSize: 10, fontWeight: 400 }}>{'Ingresos netos'}</Text>}
								rules={[{ required: true, message: 'Por favor, rellene este campo' }]}>
								<InputNumber style={{ width: '100%', borderRadius: 4 }}></InputNumber>
							</Form.Item>
						</Col>
						<Col xs={12} md={8} sm={8} lg={8} xl={6} xxl={6}>
							<Form.Item
								name={'NumeroDePagas' + index}
								label={
									<Text style={{ fontSize: 10, fontWeight: 400 }}>{`Nº de pagas al año`}</Text>
								}
								className={emptyFields.includes('provinceBuy') ? 'shadowed' : ''}
								rules={[{ required: true, message: 'Por favor, rellene este campo' }]}>
								<Select
									showSearch
									filterOption={(input, option: any) =>
										String(option?.children).toLowerCase().includes(input.toLowerCase())
									}
									style={{ width: '100%', borderRadius: 4 }}
									placeholder="Seleccionar">
									<Option key={'12'} value={'12'}>
										{'12'}
									</Option>
									<Option key={'14'} value={'14'}>
										{'14'}
									</Option>
								</Select>
							</Form.Item>
						</Col>
						<Col xs={12} md={8} sm={8} lg={8} xl={6} xxl={6}>
							<Form.Item
								name={'ComunidadAutonoma' + index}
								label={
									<Text
										style={{
											fontSize: 10,
											fontWeight: 400
										}}>{`CCAA donde recibe los ingresos`}</Text>
								}
								className={emptyFields.includes('provinceBuy') ? 'shadowed' : ''}
								rules={[{ required: true, message: 'Por favor, rellene este campo' }]}>
								<Input style={{ width: '100%', borderRadius: 4 }}></Input>
							</Form.Item>
						</Col>
					</Row>
					<Row style={{ marginTop: -16 }}>
						<Divider
							type="horizontal"
							style={{
								height: '0.5px',
								width: '100%',
								background: '#505763',
								flexGrow: 1
							}}></Divider>
						<div style={{ display: 'flex', alignItems: 'center', gap: 8, width: '100%' }}></div>
					</Row>
				</>
			);
		}

		return arrayform;
	};

	const renderValue = (value) => {
		const found = allData?.employmentContract?.find((e) => e.name === value);
		return found ? found.value : '';
	};

	const onFinish = (values) => {
		setLoading(true);
		const obj = {
			bankRequestId: bankRequestId,
			mortgage: {
				CPCompra: values.CPCompra,
				TipoDeInteres: values.TipoDeInteres,
				ImporteAFinanciar: values.ImporteAFinanciar,
				ProvinciaCompra: values.ProvinciaCompra,
				PrecioCompra: values.PrecioCompra,
				PlazoOperacion: values.PlazoOperacion,
				Ingresos: values.Ingresos,
				Interveniente: undefined
			}
		};

		const Interveniente: any = [];

		for (let index = 1; index <= numberParticipants; index++) {
			Interveniente.push({
				NroInterveniente: index.toString(),
				Nombre: values['Nombre' + index],
				PrimerApellido: values['PrimerApellido' + index],
				SegundoApellido: values['SegundoApellido' + index],
				NombreDeLaCuenta:
					values['Nombre' + index] +
					' ' +
					values['PrimerApellido' + index] +
					' ' +
					values['SegundoApellido' + index],
				FechaDeNacimiento: moment(values['FechaDeNacimiento' + index], 'DD-MM-YYYY').format(
					'YYYY-MM-DD'
				),
				TipoDeDocumento: values['TipoDeDocumento' + index],
				NumeroDeDocumento: values['NumeroDeDocumento' + index],
				Nacionalidad: values['Nacionalidad' + index],
				PaisDeResidencia: values['PaisDeResidencia' + index],
				Provincia: values['Provincia' + index],
				CodigoPostal: values['CodigoPostal' + index],
				EstadoCivil: values['EstadoCivil' + index],
				CorreoElectronico: values['CorreoElectronico' + index],
				TipoContrato: renderValue(values['TipoContrato' + index]),
				IngresosNetosMensuales: values['IngresosNetosMensuales' + index],
				NumeroDePagas: values['NumeroDePagas' + index].toString(),
				ComunidadAutonoma: values['ComunidadAutonoma' + index],
				RegimenMatrimonial: values['RegimenMatrimonial' + index]
			});
		}
		obj.mortgage.Interveniente = Interveniente;

		axios
			.post(`${env.api.url}/banks/laboral-kutxa/execute-process`, obj, {
				headers: {
					Authorization: `Bearer ${authClient.getToken()}`
				}
			})
			.then((response) => {
				if (response.data.success) {
					notification.success({
						message: 'Operación realizada',
						description: 'La petición se ha enviado correctamente a LaboralKutxa'
					});
					setLoading(false);
					navigate(`/operations/mortgages/${mortgageId}/?tab=5`);
				} else {
					notification.error({
						message: 'Error',
						description: 'Ha ocurrido un error al enviar la petición a LaboralKutxa'
					});
					setLoading(false);
				}
			})
			.catch((response) => {
				setLoading(false);
			});
	};

	const cancelSend = () => {
		setVisibleCancel(!visibleCancel);
	};

	const handleCancel = () => {
		setVisibleCancel(!visibleCancel);
	};

	const handleOk2 = () => {
		setVisibleCancel(!visibleCancel);
		navigate(`/operations/mortgages/${mortgageId}/?tab=5`);
	};

	if (allData && loading === false && documentsTypes) {
		return (
			<>
				<div style={{ marginTop: 24 }}>
					<Text className="primary-text" style={{ fontSize: 20, fontWeight: 600 }}>
						Envio a LaboralKutxa via API
					</Text>
				</div>
				<div
					style={{
						marginTop: 24,
						display: 'flex',
						background: '#EEEFF2',
						padding: 4,
						borderRadius: 4
					}}>
					<House03Icon size={24}></House03Icon>
					<Text className="primary-text" style={{ fontSize: 16, fontWeight: 400, marginLeft: 8 }}>
						Datos del negocio
					</Text>
				</div>
				<Form
					form={form}
					layout="vertical"
					name="sendMessageForm"
					className={`form-edit-data form-edit-data-${brand}`}
					initialValues={{
						Provincia:
							type === 'subrogation'
								? mortgage?.subrogation.province === 'Lleida'
									? 'Lerida'
									: mortgage?.subrogation.province
								: mortgage?.propertyWishPurchase.province === 'Lleida'
								? 'Lerida'
								: mortgage?.propertyWishPurchase.province,
						TipoContrato1: mortgage['owner1']?.activity,
						TipoContrato2: mortgage['owner2'] && mortgage['owner2']?.activity,
						ProvinciaCompra:
							type === 'subrogation'
								? mortgage?.subrogation.province === 'Lleida'
									? 'Lerida'
									: mortgage?.subrogation.province
								: mortgage?.propertyWishPurchase.province === 'Lleida'
								? 'Lerida'
								: mortgage?.propertyWishPurchase.province,

						PrecioCompra:
							type === 'mortgage'
								? mortgage?.propertyWishPurchase?.maxBudget
								: mortgage?.subrogation?.amount,
						ImporteAFinanciar: mortgage?.propertyWishPurchase?.mortgageAmount,
						PlazoOperacion: mortgage?.desiredOffer?.term,
						CPCompra:
							type === 'mortgage'
								? mortgage?.propertyWishPurchase?.postalCode
								: mortgage?.subrogation?.postalCode,
						TipoDeDocumento1: mortgage['owner1']?.idDocumentType === 'ID' ? 'DNI' : undefined,
						TipoDeDocumento2: mortgage['owner2']?.idDocumentType === 'ID' ? 'DNI' : undefined,
						Nombre1: mortgage['owner1']?.name,
						PrimerApellido1: mortgage['owner1']?.firstSurname,
						SegundoApellido1: mortgage['owner1'].lastSurname,
						FechaDeNacimiento1: moment(mortgage['owner1']?.birthdate, 'YYYY-MM-DD').format(
							'DD-MM-YYYY'
						),
						NumeroDeDocumento1: mortgage['owner1']?.nif,
						CorreoElectronico1: mortgage['owner1']?.email,
						Nombre2: mortgage['owner2'] && mortgage['owner2']?.name,
						PrimerApellido2: mortgage['owner2']?.firstSurname,
						SegundoApellido2: mortgage['owner2']?.lastSurname,
						FechaDeNacimiento2: moment(mortgage['owner2']?.birthdate, 'YYYY-MM-DD').format(
							'DD-MM-YYYY'
						),
						NumeroDeDocumento2: mortgage['owner2']?.nif,
						CorreoElectronico2: mortgage['owner2']?.email,
						Nacionalidad1: mortgage['owner1']?.nationality === 'ES' ? 'España' : undefined,
						Nacionalidad2:
							mortgage['owner2'] && mortgage['owner2']?.nationality === 'ES' ? 'España' : undefined,
						PaisDeResidencia1: mortgage['owner1']?.cityzenship === 'ES' ? 'España' : undefined,
						PaisDeResidencia2:
							mortgage['owner2'] && mortgage['owner2']?.cityzenship === 'ES' ? 'España' : undefined,
						Provincia1: mortgage['owner1']?.province,
						Provincia2: mortgage['owner2']?.province,
						CodigoPostal1: mortgage['owner1']?.postalCode,
						CodigoPostal2: mortgage['owner2'] && mortgage['owner2']?.postalCode,
						NumeroDePagas1: mortgage['owner1']?.incomesWealth?.incomes[0]?.paymentsNumber,
						NumeroDePagas2:
							mortgage['owner2'] && mortgage['owner2']?.incomesWealth?.incomes[0]?.paymentsNumber,
						Ingresos:
							numberParticipants > 1
								? parseFloat(mortgage['owner1']?.incomesWealth?.proRataMonthlyNetIncome) +
								  parseFloat(mortgage['owner2']?.incomesWealth?.proRataMonthlyNetIncome)
								: parseFloat(mortgage['owner1']?.incomesWealth?.proRataMonthlyNetIncome),
						IngresosNetosMensuales1: parseFloat(
							mortgage['owner1']?.incomesWealth?.proRataMonthlyNetIncome
						),
						IngresosNetosMensuales2: parseFloat(
							mortgage['owner2']?.incomesWealth?.proRataMonthlyNetIncome
						)
					}}
					onChange={handleFormChange}
					onFinish={onFinish}>
					<Row gutter={[32, 0]} style={{ marginTop: 16 }}>
						<Col xs={12} md={8} sm={8} lg={8} xl={6} xxl={6}>
							<Form.Item
								name={'CPCompra'}
								rules={[{ required: true, message: 'Por favor, rellene este campo' }]}
								label={<Text style={{ fontSize: 10, fontWeight: 400 }}>{`Código postal`}</Text>}>
								<Input style={{ width: '100%' }} placeholder="Código postal " />
							</Form.Item>
						</Col>
						<Col xs={12} md={8} sm={8} lg={8} xl={6} xxl={6}>
							<Form.Item
								name={'ProvinciaCompra'}
								label={<Text style={{ fontSize: 10, fontWeight: 400 }}>{`Provincia`}</Text>}
								className={emptyFields.includes('provinceBuy') ? 'shadowed' : ''}
								rules={[{ required: true, message: 'Por favor, rellene este campo' }]}>
								<ProvinceSelector placeholder="Seleccionar" style={{ width: '100%' }} />
							</Form.Item>
						</Col>

						<Col xs={12} md={8} sm={8} lg={8} xl={6} xxl={6}>
							<Form.Item
								name={'PrecioCompra'}
								label={
									<Text style={{ fontSize: 10, fontWeight: 400 }}>{'Importe de la compra'}</Text>
								}
								rules={[{ required: true, message: 'Por favor, rellene este campo' }]}>
								<InputNumber style={{ width: '100%', borderRadius: 4 }}></InputNumber>
							</Form.Item>
						</Col>
						<Col xs={12} md={8} sm={8} lg={8} xl={6} xxl={6}>
							<Form.Item
								name={'ImporteAFinanciar'}
								rules={[{ required: true, message: 'Por favor, rellene este campo' }]}
								label={
									<Text style={{ fontSize: 10, fontWeight: 400 }}>{'Importe a financiar'}</Text>
								}>
								<InputNumber style={{ width: '100%', borderRadius: 4 }}></InputNumber>
							</Form.Item>
						</Col>

						<Col xs={12} md={8} sm={8} lg={8} xl={6} xxl={6}>
							<Form.Item
								name={'PlazoOperacion'}
								rules={[{ required: true, message: 'Por favor, rellene este campo' }]}
								label={
									<Text style={{ fontSize: 10, fontWeight: 400 }}>{'Plazo deseado(meses)'}</Text>
								}>
								<InputNumber style={{ width: '100%', borderRadius: 4 }}></InputNumber>
							</Form.Item>
						</Col>
						<Col xs={12} md={8} sm={8} lg={8} xl={6} xxl={6}>
							<Form.Item
								name={'TipoDeInteres'}
								rules={[{ required: true, message: 'Por favor, rellene este campo' }]}
								label={<Text style={{ fontSize: 10, fontWeight: 400 }}>{'Tipo de interes'}</Text>}>
								<InputNumber style={{ width: '100%', borderRadius: 4 }}></InputNumber>
							</Form.Item>
						</Col>

						<Col xs={12} md={8} sm={8} lg={8} xl={6} xxl={6}>
							<Form.Item
								name={'Ingresos'}
								rules={[{ required: true, message: 'Por favor, rellene este campo' }]}
								label={
									<Text style={{ fontSize: 10, fontWeight: 400 }}>
										{'Ingresos mensuales de los intervinientes'}
									</Text>
								}>
								<InputNumber style={{ width: '100%', borderRadius: 4 }}></InputNumber>
							</Form.Item>
						</Col>
					</Row>
					<div
						style={{
							marginTop: 24,
							display: 'flex',
							background: '#EEEFF2',
							padding: 4,
							borderRadius: 4
						}}>
						<ContactBookIcon size={24}></ContactBookIcon>
						<Text className="primary-text" style={{ fontSize: 16, fontWeight: 400, marginLeft: 8 }}>
							Datos de los titulares
						</Text>
					</div>
					{renderForm()}

					<Row style={{ justifyContent: 'center', marginTop: 20 }}>
						<Button style={{ width: 96 }} onClick={() => cancelSend()}>
							Atras
						</Button>
						<Button style={{ marginLeft: 8, width: 96 }} type="primary" htmlType="submit">
							Aceptar
						</Button>
					</Row>
				</Form>
				<Modal
					className={`modal-common`}
					cancelButtonProps={{ style: { width: 96 } }}
					okButtonProps={{ style: { width: 96 } }}
					open={visibleCancel}
					title={<Text style={{ fontSize: '14px', fontWeight: '600px' }}>{'Cancelar envío'}</Text>}
					okText={'Aceptar'}
					cancelText={'Cancelar'}
					width={404}
					onCancel={handleCancel}
					onOk={handleOk2}>
					<Text style={{ fontSize: '12px', fontWeight: '400px' }}>
						{'¿Aceptas la cancelación de del envio a Laboral Kutxa?'}
					</Text>
				</Modal>
			</>
		);
	} else {
		return (
			<>
				<div style={{ textAlign: 'center', height: '40vh' }}>
					<Spin style={{ position: 'absolute', top: '30%' }} size="large" />
				</div>
				<div style={{ textAlign: 'center', height: '80vh' }}>
					<Text style={{ marginTop: 34, fontSize: 14, fontWeight: 500 }}>
						Por favor, no cierre ni recargue la pagina, puede tardar hasta 3 minutos...
					</Text>
				</div>
			</>
		);
	}
};
export default TableLaboralKutxa;
